import React, { useMemo } from 'react'

import { Grid } from '@the-platform-group/component-library'
import { AsyncSelect } from '@the-platform-group/component-library'

import SecuritySelect from 'components/Select/SecuritySelect'

import { debouncedLoadCustomers } from 'utils/optionsLoaders'
import SelectEntity from './SelectEntity'

const EntitySelectionActions = ({
  selectedCustomer,
  setSelectedCustomer,
  selectedSecurity,
  setSelectedSecurity,
  setSelectedEntityId,
  setSelectedEntityType,
  setSelectedDataSource,
}) => {
  const optionsLoader = useMemo(() => {
    return term => debouncedLoadCustomers({ term, state: 'active' })
  }, [])

  const handleChangeSecurity = security => {
    setSelectedSecurity(security)
  }

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid item container xs={12} sm={5} spacing={2} alignItems="center">
        <Grid item xs={12} sm={6}>
          <AsyncSelect
            includeClearAll
            id="customerId"
            label="Search Customer"
            variant="outlined"
            value={selectedCustomer}
            onChange={setSelectedCustomer}
            optionsLoader={optionsLoader}
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SecuritySelect
            id="securityId"
            label="Select a Security"
            value={selectedSecurity}
            onChange={handleChangeSecurity}
            margin="none"
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} sm={7} spacing={2} alignItems="center">
        <Grid item container direction="row">
          <SelectEntity
            setSelectedEntityId={setSelectedEntityId}
            setSelectedEntityType={setSelectedEntityType}
            selectedCustomer={selectedCustomer}
            setSelectedDataSource={setSelectedDataSource}
            selectedSecurityId={selectedSecurity?.id}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EntitySelectionActions
